<template>
  <div>
    <b-row class="mb-2">
      <b-col md="4">
        <b-form-input v-model="filter" size="sm" placeholder="Søk etter navn, fartøy eller årsak" />
      </b-col>
      <b-col class="small text-muted d-flex align-items-center">
        Viser endringer som gjelder perioden {{ fmt(plan.from) }} – {{ fmt(plan.to) }}.
      </b-col>
    </b-row>

    <b-table
      show-empty
      small
      hover
      stacked="sm"
      :items="rows"
      :fields="fields"
      :filter="filter"
      sort-by="sortKey"
      empty-text="Ingen fravær eller mannskapsendringer i perioden"
      empty-filtered-text="Ingen treff"
    >
      <template #cell(when)="row">
        <span v-if="row.item.order">Ordre {{ row.item.ordernumber || "" }}</span>
        <span v-else>{{ fmt(row.item.from_date) }} – {{ fmt(row.item.to_date) }}</span>
      </template>
      <template #cell(out)="row">
        <span v-if="row.item.crew_out">{{ row.item.crew_out.name }}</span>
        <span v-else class="text-muted">–</span>
      </template>
      <template #cell(in)="row">
        <span v-if="row.item.crew_in">{{ row.item.crew_in.name }}</span>
        <span v-else class="text-muted">–</span>
      </template>
      <template #cell(reasonText)="row">
        <b-badge pill variant="light">{{ row.item.reasonText }}</b-badge>
      </template>
      <template #cell(actions)="row">
        <b-button size="sm" variant="primary" class="mr-1" @click="$emit('edit', row.item)">Rediger</b-button>
        <b-button size="sm" variant="outline-danger" :disabled="deleting === row.item.id" @click="remove(row.item)">Slett</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import dayjs from "dayjs";
import api, { reasonLabel, errorText } from "./api";

export default {
  name: "CrewChanges",
  props: {
    plan: { type: Object, required: true },
  },
  data() {
    return {
      filter: null,
      deleting: null,
      fields: [
        { key: "when", label: "Gjelder" },
        { key: "vesselName", label: "Fartøy", sortable: true },
        { key: "skiftName", label: "Skift", sortable: true },
        { key: "out", label: "Ut" },
        { key: "in", label: "Inn" },
        { key: "reasonText", label: "Årsak", sortable: true },
        { key: "note", label: "Notat" },
        { key: "actions", label: "" },
      ],
    };
  },
  computed: {
    rows() {
      const vessels = {};
      const orders = {};
      this.plan.vessels.forEach((v) => {
        vessels[v.id] = v.name;
        v.orders.forEach((o) => (orders[o.id] = o));
      });
      const skifts = {};
      this.plan.skifts.forEach((s) => (skifts[s.id] = s.name));

      return this.plan.changes.map((c) => {
        const order = c.order ? orders[c.order] : null;
        return {
          ...c,
          ordernumber: order ? order.ordernumber : null,
          vesselName: vessels[c.vessel] || (c.vessel ? "" : "Alle"),
          skiftName: skifts[c.skift] || (order && order.skift_name) || (c.skift || c.order ? "" : "Alle"),
          reasonText: reasonLabel(c.reason),
          sortKey: order ? order.startdate : c.from_date,
          // searchable text for b-table's filter
          outName: c.crew_out ? c.crew_out.name : "",
          inName: c.crew_in ? c.crew_in.name : "",
        };
      });
    },
  },
  methods: {
    fmt(date) {
      return date ? dayjs(date).format("DD.MM.YYYY") : "";
    },
    async remove(change) {
      const ok = await this.$bvModal.msgBoxConfirm("Slette endringen? Mannskapet regnes ut på nytt for berørte ordrer.", {
        title: "Slett endring",
        okTitle: "Slett",
        cancelTitle: "Avbryt",
        okVariant: "danger",
      });
      if (!ok) return;
      this.deleting = change.id;
      try {
        await api.deleteChange(change.id);
        this.$emit("changed");
      } catch (error) {
        this.$bvToast.toast(errorText(error), { title: "Feil", variant: "danger", solid: true });
      } finally {
        this.deleting = null;
      }
    },
  },
};
</script>
